import React from "react";
import "./EducationCard.css";

const EducationCard = ({ details }) => {
	return (
	  <div className="work-experience-card">
		<h6>{details.title}</h6>
		<div className="work-duration">{details.date}</div>
		<ul>
		  {details.responsibilities.map((item, index) => (
			<li key={index}>{item}</li>
		  ))}
		</ul>
	  </div>
	);
  };
  

export default EducationCard;
